import React from 'react';

const ChevronRight = ({ className }: { className?: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 11.808 18.591"
			className={className}
		>
			<path
				fill="none"
				stroke="currentColor"
				strokeWidth="2"
				d="m10.396 9.296-7.851 7.879-1.131-1.134 6.77-6.763-6.752-6.745 1.113-1.116Z"
			/>
		</svg>
	);
};

export default ChevronRight;
